// extracted by mini-css-extract-plugin
module.exports = {"warningOption":"_1CuEj1cV","warningOptionLabel":"_2fPNdFsx"};